import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static values = {
    id: String,
    variation: String
  }

  connect() {
    console.log('connected');
    this.submitOnChange = this.debounce(this.submitOnChange.bind(this), 200);
    this.submitOnInput = this.debounce(this.submitOnInput.bind(this), 1000);
  }

  submitForm(event) {
    event.preventDefault();
    event.target.form.submit();
  }

  /* auto submit form when select change */
  submitOnChange(event) {
    this.submitForm(event);
  }

  /* auto submit form when input change */
  submitOnInput(event) {
    this.submitForm(event);
  }

  debounce(fn, delay) {
    let timeoutId;
    return function (...args) {
      clearTimeout(timeoutId);
      timeoutId = setTimeout(() => {
        timeoutId = null;
        fn(...args);
      }, delay);
    };
  }
}
